import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { Description } from '../../../../shared/vulns/Drawer';
import * as PackageInventoryStore from '../../../../../redux/packageInventory';

/**
 * Container component for the VulnerabilityDrawerDescription
 */
const PackageVersionVulnerabilityDrawerDescription: VoidFunctionComponent = () => {
  const { isLoading } = useSelector(PackageInventoryStore.selectors.getAsyncStatusGetSelectedVuln);
  const description = useSelector(PackageInventoryStore.selectors.getSelectedVulnDescription);
  return (
    <Description
      isLoading={isLoading}
      description={description}
    />
  );
};

export default PackageVersionVulnerabilityDrawerDescription;
